import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { DetailWebsitePage } from '../detail-website/detail-website.page';

@Component({
  selector: 'app-website',
  templateUrl: './website.page.html',
  styleUrls: ['./website.page.scss'],
})
export class WebsitePage implements OnInit {

  constructor(public navCtrl: NavController,
  			  public modalCtrl: ModalController) { }

  ngOnInit() {
  }

  bacaWeb(){
  	this.navCtrl.navigateForward('/website/website-detail');
  }

  async modalWeb() {
    const modal = await this.modalCtrl.create({
      component: DetailWebsitePage,
    });
    return await modal.present();
  }

}
